.sidebar {
  background: var(--white);
  height: 100vh;
  position: relative;
}

.avatar {
  position: relative;
  width: calc(100% - 20px);
  margin: 30px 10px 0;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  background: var(--white);
  border: 1px solid color-mix(in srgb, var(--black) 25%, transparent);
  font: inherit;
  cursor: pointer;
  border-radius: 6px;
  transition: background-color 150ms ease;
}

.avatar:hover {
  background: color-mix(in srgb, var(--purple) 10%, transparent);
}

.avatar .img {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 100%;
  background-position: center;
  background-size: cover;
}

.avatar .bubble {
  position: absolute;
  left: 42px;
  bottom: 8px;
  width: 12px;
  height: 12px;
  border-radius: 100%;
  background-color: #e74c3c;
}

.avatar .name {
  flex: 1;
  text-align: left;
  font-size: 0.95em;
  color: var(--black);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.avatar .chevron {
  color: var(--gray);
}

.nav {
  margin-top: 50px;
  padding: 0 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.nav .link {
  display: block;
  position: relative;
  text-decoration: none;
  padding: 8px 20px;
  border-radius: 4px;
  font-size: 1.2em;
  cursor: pointer;
  color: var(--black);
  transition: background-color 150ms ease, color 150ms ease;
}

.nav .link:hover {
  background: color-mix(in srgb, var(--purple) 10%, transparent);
  color: var(--black);
}

.nav .last {
  margin-top: 30px;
}

/* Same Chip as the movie cards' categories; only spacing is ours. */
.nav .beta {
  margin-left: 4px;
  vertical-align: middle;
}

.nav .active {
  background: color-mix(in srgb, var(--purple) 15%, transparent);
  color: var(--black);
}

.nav .active::after {
  content: '';
  position: absolute;
  right: -10px;
  top: 0;
  bottom: 0;
  width: 4px;
  border-radius: 2px 0 0 2px;
  background: var(--purple);
}
